import axiosInstance from '../axios';

export const fetchFavorites = async () => {
  const response = await axiosInstance.get('/favorites');
  return response.data.data;
};

export const addFavorite = async (propertyId) => {
  const response = await axiosInstance.post(`/favorites/${propertyId}`);
  return response.data;
};

export const removeFavorite = async (propertyId) => {
  const response = await axiosInstance.delete(`/favorites/${propertyId}`);
  return response.data;
};
